export default __webpack_public_path__ + "static/media/infoBlack.2003309e.svg";